String.prototype.splice = function (index, length, replacement) {
  return this.slice(0, index) + replacement + this.slice(index + Math.abs(length));
};

String.prototype.capitalize = function () {
  return this.slice(0, 1).toUpperCase() + this.slice(1);
};